/* CardiVores — playful layer behaviour. Loaded deferred on every page. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['#e8571f', '#ffc531', '#9a6be0', '#1fa79a', '#1b1420'];
  var SHAPES = ['tri', 'dot', 'sq'];
  var lastAddButton = null;

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[name="add"], .quick-add__submit');
      if (button) lastAddButton = button;
    },
    true
  );

  function confetti(origin) {
    var rect = origin.getBoundingClientRect();
    var x = rect.left + rect.width / 2;
    var y = rect.top + rect.height / 2;
    for (var i = 0; i < 18; i++) {
      var piece = document.createElement('span');
      piece.className = 'cv-confetti cv-confetti--' + SHAPES[i % SHAPES.length];
      piece.style.background = COLORS[i % COLORS.length];
      piece.style.left = x + 'px';
      piece.style.top = y + 'px';
      document.body.appendChild(piece);

      var angle = (Math.PI * 2 * i) / 18 + Math.random() * 0.4;
      var distance = 60 + Math.random() * 90;
      var dx = Math.cos(angle) * distance;
      var dy = Math.sin(angle) * distance - 40;
      var animation = piece.animate(
        [
          { transform: 'translate(-50%, -50%) scale(0.4) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(1) rotate(' + (Math.random() * 540 - 270) + 'deg)', opacity: 1, offset: 0.6 },
          { transform: 'translate(' + dx + 'px,' + (dy + 70) + 'px) scale(0.6) rotate(' + (Math.random() * 720 - 360) + 'deg)', opacity: 0 },
        ],
        { duration: 800 + Math.random() * 300, easing: 'cubic-bezier(0.2, 0.8, 0.3, 1)' }
      );
      animation.onfinish = piece.remove.bind(piece);
    }
  }

  function wiggleCart() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    bubble.classList.remove('cv-wiggle');
    void bubble.offsetWidth;
    bubble.classList.add('cv-wiggle');
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      wiggleCart();
      if (!reduceMotion && lastAddButton && lastAddButton.isConnected) confetti(lastAddButton);
      document.dispatchEvent(new CustomEvent('cv:added-to-cart'));
    });
  }

  /* Hero: mascot leans toward the pointer. Mouse only — touch devices get the idle float. */
  var hero = document.querySelector('.cv-hero');
  if (hero && !reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    hero.addEventListener('pointermove', function (event) {
      var rect = hero.getBoundingClientRect();
      hero.style.setProperty('--cv-px', ((event.clientX - rect.left) / rect.width - 0.5).toFixed(3));
      hero.style.setProperty('--cv-py', ((event.clientY - rect.top) / rect.height - 0.5).toFixed(3));
    });
    hero.addEventListener('pointerleave', function () {
      hero.style.setProperty('--cv-px', 0);
      hero.style.setProperty('--cv-py', 0);
    });
  }

  /* ---------- Lightbox: "Who are we" tiles carry text, so let people open them ---------- */
  var tiles = Array.prototype.slice.call(document.querySelectorAll('.multicolumn-card__image-wrapper'));
  var lightbox, lightboxImg, lightboxCount, current = 0;

  function largeSrc(tile) {
    var img = tile.querySelector('img');
    var src = img.currentSrc || img.src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=1600') : src;
  }

  function show(index) {
    current = (index + tiles.length) % tiles.length;
    lightboxImg.src = largeSrc(tiles[current]);
    lightboxImg.alt = tiles[current].querySelector('img').alt;
    lightboxCount.textContent = current + 1 + ' / ' + tiles.length;
  }

  function buildLightbox() {
    lightbox = document.createElement('dialog');
    lightbox.className = 'cv-lightbox';
    lightbox.innerHTML =
      '<div class="cv-lightbox__stage"><img class="cv-lightbox__img" alt=""></div>' +
      '<button type="button" class="cv-lightbox__btn cv-lightbox__btn--close" aria-label="Close">&times;</button>' +
      '<button type="button" class="cv-lightbox__btn cv-lightbox__btn--prev" aria-label="Previous">&#8249;</button>' +
      '<button type="button" class="cv-lightbox__btn cv-lightbox__btn--next" aria-label="Next">&#8250;</button>' +
      '<div class="cv-lightbox__count"></div>';
    document.body.appendChild(lightbox);
    lightboxImg = lightbox.querySelector('img');
    lightboxCount = lightbox.querySelector('.cv-lightbox__count');
    var touchX = null;
    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('.cv-lightbox__btn--prev')) show(current - 1);
      else if (event.target.closest('.cv-lightbox__btn--next')) show(current + 1);
      else if (event.target !== lightboxImg) lightbox.close();
    });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
    lightbox.addEventListener('touchstart', function (event) { touchX = event.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function (event) {
      if (touchX === null) return;
      var dx = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
    });
  }

  if (tiles.length && typeof HTMLDialogElement !== 'undefined') {
    tiles.forEach(function (tile, index) {
      if (!tile.querySelector('img')) return;
      tile.classList.add('cv-zoomable');
      tile.setAttribute('role', 'button');
      tile.setAttribute('tabindex', '0');
      tile.setAttribute('aria-label', 'Open image ' + (index + 1));
      function open() {
        if (!lightbox) buildLightbox();
        show(index);
        lightbox.showModal();
      }
      tile.addEventListener('click', open);
      tile.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
        }
      });
    });
  }

  /* ---------- Corner mascot ---------- */
  var mascot = document.getElementById('cv-mascot');
  var dismissed = false;
  try { dismissed = sessionStorage.getItem('cv-mascot-hidden') === '1'; } catch (e) {}

  if (mascot) {
    var bubble = mascot.querySelector('.cv-mascot__bubble');
    var poseImg = mascot.querySelector('[data-pose-img]');
    var poses = {};
    try { poses = JSON.parse(mascot.querySelector('[data-poses]').textContent); } catch (e) {}
    /* Tap line N is acted out with pose N; extra lines reuse the list from the start. */
    var TAP_POSES = ['curious', 'easy', 'annoyed', 'laughing', 'invite', 'surrender'];
    var poseTimer;

    function preload(name) {
      if (poses[name]) new Image().src = poses[name];
    }

    /* Poses change with a quick squash: the picture is swapped while he is compressed, so it reads as him moving. */
    function swapTo(name) {
      var url = poses[name];
      if (!url || poseImg.getAttribute('src') === url) return;
      var next = new Image();
      next.src = url;
      var ready = next.decode ? next.decode().catch(function () {}) : Promise.resolve();
      ready.then(function () {
        if (reduceMotion) {
          poseImg.src = url;
          return;
        }
        mascot.classList.remove('is-swap');
        void mascot.offsetWidth;
        mascot.classList.add('is-swap');
        setTimeout(function () { poseImg.src = url; }, 90);
        setTimeout(function () { mascot.classList.remove('is-swap'); }, 380);
      });
    }

    function setPose(name, holdMs) {
      if (!poses[name]) return;
      clearTimeout(poseTimer);
      swapTo(name);
      if (name !== 'idle') poseTimer = setTimeout(function () { swapTo('idle'); }, holdMs || 3200);
    }

    /* The tap story ends by sending the shopper to a product; after that he no longer reacts to taps this visit. */
    var storyUrl = mascot.dataset.storyUrl;
    var storyState = null;
    try { storyState = sessionStorage.getItem('cv-mascot-story'); } catch (e) {}
    function setStory(value) {
      storyState = value;
      try { sessionStorage.setItem('cv-mascot-story', value); } catch (e) {}
    }
    function onStoryPage() {
      return storyUrl && location.pathname.replace(/\/$/, '').endsWith(storyUrl.split('?')[0].replace(/\/$/, ''));
    }
    function finishStory() {
      setStory('done');
      mascot.classList.add('is-done');
      setPose('invite', 5000);
      say(mascot.dataset.storyPhrase, 5000);
    }
    var phrases = [];
    try { phrases = JSON.parse(mascot.querySelector('[data-phrases]').textContent).filter(Boolean); } catch (e) {}
    var clickPhrases = [];
    try { clickPhrases = JSON.parse(mascot.querySelector('[data-click-phrases]').textContent).filter(Boolean); } catch (e) {}
    var clickIndex = 0, lastClick = 0;
    var TRICKS = ['is-jump', 'is-spin', 'is-wiggle', 'is-peek'];
    var phraseIndex = 0, talkTimer, trickTimer, idleTimer;

    function trick(name) {
      if (reduceMotion) return;
      TRICKS.forEach(function (t) { mascot.classList.remove(t); });
      void mascot.offsetWidth;
      mascot.classList.add(name || TRICKS[Math.floor(Math.random() * TRICKS.length)]);
      clearTimeout(trickTimer);
      trickTimer = setTimeout(function () {
        TRICKS.forEach(function (t) { mascot.classList.remove(t); });
      }, 1700);
    }

    function say(text, holdMs) {
      if (!text) return;
      bubble.textContent = text;
      mascot.classList.add('is-talking');
      clearTimeout(talkTimer);
      talkTimer = setTimeout(function () { mascot.classList.remove('is-talking'); }, holdMs || 3200);
    }

    function nextPhrase() {
      if (!phrases.length) return;
      say(phrases[phraseIndex % phrases.length]);
      phraseIndex++;
    }

    /* Every so often it does something on its own, but only while the tab is visible. */
    function scheduleIdle() {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        if (!document.hidden && !mascot.classList.contains('is-min')) {
          trick();
          if (Math.random() < 0.4) {
            setPose('invite');
            nextPhrase();
          }
        }
        scheduleIdle();
      }, 14000 + Math.random() * 10000);
    }

    /* Sit above whatever else is pinned to the bottom of the screen. Bars can stack (a sticky add-to-cart bar
       on top of an upsell or preview bar), so walk upward until the corner is clear. A fixed layer that covers
       most of the screen is a drawer or modal: step aside for it instead of floating over it. */
    function clearBottomBars() {
      var x = window.innerWidth - 40, vh = window.innerHeight, y = vh - 6, offset = 0, covered = false;
      for (var guard = 0; guard < 8 && y > vh * 0.4; guard++) {
        var hit = null, stack = document.elementsFromPoint(x, y);
        for (var i = 0; i < stack.length; i++) {
          if (!mascot.contains(stack[i])) { hit = stack[i]; break; }
        }
        var bar = null;
        for (var el = hit; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
          if (getComputedStyle(el).position === 'fixed') { bar = el; break; }
        }
        if (!bar) break;
        var rect = bar.getBoundingClientRect();
        if (rect.height > vh * 0.7) { covered = true; break; }
        offset = Math.max(offset, vh - rect.top);
        y = rect.top - 6;
      }
      mascot.style.setProperty('--cv-mascot-bottom', Math.min(offset, vh * 0.55) + 'px');
      mascot.classList.toggle('is-covered', covered);
    }

    if (storyState === 'done') mascot.classList.add('is-done');
    mascot.hidden = false;
    clearBottomBars();
    if (dismissed) mascot.classList.add('is-min');
    setTimeout(function () {
      mascot.classList.add('is-in');
      setTimeout(function () {
        if (storyState === 'arrived' && onStoryPage()) finishStory();
        else if (!dismissed) nextPhrase();
      }, 900);
      setTimeout(function () {
        preload(TAP_POSES[0]);
        preload('celebrate');
        preload('invite');
      }, 2500);
    }, 1200);
    /* App bars slide in late and on their own schedule, so re-check for a while and whenever something finishes animating. */
    var checks = 0;
    var checkTimer = setInterval(function () {
      clearBottomBars();
      if (++checks >= 40) clearInterval(checkTimer);
    }, 500);
    var settleTimer;
    document.addEventListener('transitionend', function (event) {
      if (mascot.contains(event.target)) return;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(clearBottomBars, 200);
    });
    window.addEventListener('resize', clearBottomBars);
    var scrollTimer;
    window.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(clearBottomBars, 300);
    }, { passive: true });
    scheduleIdle();

    mascot.querySelector('.cv-mascot__body').addEventListener('click', function () {
      if (storyState === 'done') return;
      /* The tap lines escalate like a conversation, so restart the story after a pause. */
      var now = Date.now();
      if (now - lastClick > 12000) clickIndex = 0;
      lastClick = now;
      scheduleIdle();

      if (clickIndex >= clickPhrases.length) {
        if (!storyUrl) {
          clickIndex = 0;
        } else if (onStoryPage()) {
          finishStory();
          return;
        } else {
          setStory('arrived');
          location.href = storyUrl;
          return;
        }
      }
      setPose(TAP_POSES[clickIndex % TAP_POSES.length]);
      preload(TAP_POSES[(clickIndex + 1) % TAP_POSES.length]);
      say(clickPhrases[clickIndex]);
      clickIndex++;
    });

    function setMinimised(min) {
      dismissed = min;
      mascot.classList.toggle('is-min', min);
      mascot.classList.remove('is-talking');
      try { sessionStorage.setItem('cv-mascot-hidden', min ? '1' : '0'); } catch (e) {}
    }
    mascot.querySelector('.cv-mascot__close').addEventListener('click', function () { setMinimised(true); });
    mascot.querySelector('.cv-mascot__restore').addEventListener('click', function () {
      setMinimised(false);
      trick('is-jump');
      scheduleIdle();
    });

    document.addEventListener('cv:added-to-cart', function () {
      if (mascot.classList.contains('is-min')) return;
      trick('is-jump');
      say(mascot.dataset.cartPhrase);
      setPose('celebrate');
    });
  }
})();
